(() => {
  const root = document.querySelector('[data-bike-finder]');
  if (!root) return;
  const dataEl = root.querySelector('[data-finder-json]');
  const products = dataEl ? JSON.parse(dataEl.textContent) : [];
  const steps = [...root.querySelectorAll('[data-step]')];
  const progress = root.querySelector('[data-progress]');
  const results = root.querySelector('[data-results]');
  const answers = {};
  let index = 0;

  const showStep = () => {
    steps.forEach((step, i) => { step.hidden = i !== index; });
    if (progress) progress.style.width = `${((index + 1) / (steps.length + 1)) * 100}%`;
  };

  const scoreProduct = (product) => {
    let score = 0;
    const tags = (product.tags || []).map((t) => t.toLowerCase());
    const meta = product.metafields || {};
    const hay = `${tags.join(' ')} ${(product.type || '')} ${JSON.stringify(meta)}`.toLowerCase();
    const use = answers.use;
    if (use === 'by' && /(by|hverdag|city|urban)/.test(hay)) score += 3;
    if (use === 'trekking' && /(trekking|tur|pendl)/.test(hay)) score += 3;
    if (use === 'terrain' && /(fat|terræn|terrain|mtb)/.test(hay)) score += 3;
    if (use === 'mixed' && /(by|trekking|hverdag)/.test(hay)) score += 2;
    const distance = answers.distance;
    if (distance === 'long' && /(lang|80|90|100|120)/.test(hay)) score += 2;
    if (distance === 'medium' && /(mellem|50|60|70)/.test(hay)) score += 2;
    if (distance === 'short' && /(kort|by|30|40)/.test(hay)) score += 2;
    if (answers.fold === 'yes' && /(fold|sammenklap)/.test(hay)) score += 4;
    if (answers.fold === 'no' && !/(fold)/.test(hay)) score += 1;
    if (answers.cargo === 'yes' && /(cargo|lad|familie|barn)/.test(hay)) score += 4;
    if (answers.step === 'yes' && /(lav|indstigning|step.through|dame)/.test(hay)) score += 3;
    const prio = answers.priority;
    if (prio === 'comfort' && /(komfort|comfort|lav)/.test(hay)) score += 2;
    if (prio === 'range' && /(rækkevidde|batteri|range)/.test(hay)) score += 2;
    if (prio === 'compact' && /(kompakt|fold|lille)/.test(hay)) score += 2;
    if (prio === 'terrain' && /(terræn|fat|mtb)/.test(hay)) score += 2;
    return score;
  };

  const reasonFor = (product) => {
    const bits = [];
    if (answers.use) bits.push('den passer til den type ture, du har valgt');
    if (answers.fold === 'yes') bits.push('den kan foldes');
    if (answers.cargo === 'yes') bits.push('den kan transportere børn eller bagage');
    if (answers.step === 'yes') bits.push('den har nem indstigning');
    if (answers.priority) bits.push('den matcher din prioritet');
    return `${product.title} er valgt, fordi ${bits.join(', ') || 'dens egenskaber ligger tæt på dine svar'}.`;
  };

  const renderResults = () => {
    steps.forEach((step) => { step.hidden = true; });
  const ranked = products
      .map((p) => ({ ...p, score: scoreProduct(p) }))
      .filter((p) => p.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 3);
    if (!ranked.length) {
      const catalog = window.VK_NAV?.catalogUrl || '/collections/elcykler';
      const ride = window.VK_NAV?.viewUrl ? window.VK_NAV.viewUrl('book-provetur') : '/pages/book-provetur';
      results.innerHTML = `<div class="empty-state"><h3 class="h3">Vi fandt ikke et sikkert match</h3><p>Prøv andre svar, se hele udvalget, eller book en prøvetur – så tager vi samtalen i stedet.</p><div class="product-actions" style="justify-content:center"><a class="btn" href="${catalog}">Se alle elcykler</a><a class="btn btn--secondary" href="${ride}">Book prøvetur</a></div></div>`;
      results.hidden = false;
      return;
    }
    results.hidden = false;
    const ride = window.VK_NAV?.viewUrl ? window.VK_NAV.viewUrl('book-provetur') : '/pages/book-provetur';
    results.innerHTML = `<h2 class="h2">Dine bud</h2><p class="lede">Tre modeller, der ligger tæt på dine svar. Book en prøvetur på den, der føles rigtig.</p><div class="grid grid-3">${ranked.map((p) => `
      <article class="card">
        <div class="card__media">${p.image ? `<img src="${p.image}" alt="${p.title}">` : ''}</div>
        <div class="card__body">
          <h3 class="h3">${p.title}</h3>
          <p>${reasonFor(p)}</p>
          <div class="product-actions">
            <a class="btn" href="${p.url}">Se cyklen</a>
            <a class="btn btn--secondary" href="${ride}">Prøvetur</a>
          </div>
        </div>
      </article>`).join('')}</div>`;
  };

  root.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-choice]');
    if (choice) {
      const step = choice.closest('[data-step]');
      step.querySelectorAll('.choice').forEach((el) => el.classList.remove('is-selected'));
      choice.classList.add('is-selected');
      answers[choice.dataset.answerKey] = choice.dataset.choice;
    }
    if (event.target.matches('[data-next]')) {
      const current = steps[index];
      if (!current.querySelector('.choice.is-selected')) return;
      index += 1;
      if (index >= steps.length) renderResults();
      else showStep();
    }
    if (event.target.matches('[data-prev]')) {
      index = Math.max(0, index - 1);
      showStep();
    }
  });

  showStep();
})();
